import DomainResource from '@/fhirworks/DomainResource';
import Identifier from '@/fhirworks/types/Identifier';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';
import Reference from '@/fhirworks/types/Reference';
import ProvenanceEntity from '@/fhirworks/ProvenanceEntity';
import Signature from '@/fhirworks/Signature';
import merge from 'lodash/merge';

export default class Provenance extends DomainResource {
    static __className = 'Provenance';

    __objectStructure = {
        identifier: [Identifier],
        target: [Reference],
        recorded: String,
        agent: [Signature],
        reason: [CodeableConcept],
        // Core R4, and the only pointer a revision has back to the values it replaced.
        entity: [ProvenanceEntity],
        signature: [Signature],
    };
    constructor(constructJson, className = 'Provenance') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
